import styles from './sportModul.module.css';
import { getBackgroundColor, getTextColor } from '../../../code/ColorHandler';
import PersonCard from '../PersonCard/PersonCard';
import { useLocation } from 'react-router-dom';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
function renderDraftContent(rawContent) {
    if (!rawContent) return null;

    try {
        const contentState = convertFromRaw(JSON.parse(rawContent));
        const html = stateToHTML(contentState);
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    } catch (e) {
        console.error("Error parsing Draft.js content:", e);
        return null;
    }
}
function formatWeekdays(rule) {
    const dayMap = {
        MO: "Montags",
        TU: "Dienstags",
        WE: "Mittwochs",
        TH: "Donnerstags",
        FR: "Freitags",
        SA: "Samstags",
        SU: "Sonntags"
    };
    const days = rule.match(/BYDAY=([A-Z,]+)/)?.[1].split(",") || [];
    const localized = days.map((day) => dayMap[day] || day);

    if (localized.length === 1) return localized[0];
    if (localized.length === 2) return `${localized[0]} & ${localized[1]}`;
    return `${localized.slice(0, -1).join(", ")} & ${localized.slice(-1)}`;
}

function formatDate(isoDate) {
    return new Date(isoDate).toLocaleDateString("de-DE", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
const SportModul = ({ modul }) => {
    const location = useLocation();
    const color = getBackgroundColor(location);
    const textColor = getTextColor(location);
    const [showExceptions, setShowExceptions] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [assignmentsDetails, setAssignmentsDetails] = useState([]);
    const assignments = useMemo(() => modul.parent.assignments || [], [modul.parent.assignments])
    useEffect(() => {
        async function fetchLocations() {
            const weekdayOrder = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

            const getDayIndex = (recurrenceRule) => {
                const match = recurrenceRule?.match(/BYDAY=(\w{2})/);
                return match ? weekdayOrder.indexOf(match[1]) : -1;
            };

            const updatedAppointments = await Promise.all(
                modul.parent.appointments.map(async (a) => {
                    if (a.location_id) {
                        const res = await fetch(`/api/sportstaetten/${a.location_id}`);
                        const data = await res.json();
                        return {
                            ...a,
                            location: {
                                name: data.bezeichnung ? `${data.bezeichnung}: ${data.name}` : `${data.name}`,
                                link: data.maps_link
                            }
                        };
                    }
                    return {
                        ...a,
                        location: {
                            name: a.location_text,
                            link: "#"
                        }
                    };
                })
            );

            // ✅ Sort after resolving location info
            updatedAppointments.sort((a, b) => {
                const dayA = getDayIndex(a.recurrence_rule);
                const dayB = getDayIndex(b.recurrence_rule);
                if (dayA !== dayB) return dayA - dayB;

                const dateA = a.appointment_date || '';
                const dateB = b.appointment_date || '';
                if (dateA !== dateB) return dateA.localeCompare(dateB);

                return a.start_time.localeCompare(b.start_time);
            });

            setAppointments(updatedAppointments);
        }

        fetchLocations();
    }, [modul.parent.appointments]);
    useEffect(() => {
        async function fetchAssignmentsDetails() {
            try {
                const promises = assignments.map(a => axios.get(`/api/assignments/${a.id}`));
                const responses = await Promise.all(promises);
                const details = responses.map(res => res.data);
                setAssignmentsDetails(details);
            } catch (error) {
                console.error("Error fetching assignment details:", error);
            }
        }

        if (assignments.length > 0) {
            fetchAssignmentsDetails();
        }
    }, [assignments]);
    // your existing code for people, but now with details
    const peopleCount = assignmentsDetails.length;          // 0‒3

    /** choose one of 3 predefined grid variants */
    const gridVariant =
        peopleCount === 0 ? styles.noPerson :
            peopleCount === 1 ? styles.sidebarLayoutOne :
                peopleCount === 2 ? styles.sidebarLayoutTwo : // 1-2 ppl
                    styles.peopleTop;       // 3 ppl
    console.log(modul);
    if (modul.id == 150) {
        console.log(modul)
        console.log(appointments)
    }
    return (
        <div className={`${styles.modulContainer} ${gridVariant}`}>
            <div className={styles.persons}>
                {assignmentsDetails.map((personDetail, idx) => {
                    // use your existing getPerson to map data
                    return (
                        // <div key={idx} className={styles.personCard}>
                        <PersonCard person={{ ...personDetail, color, colorText: textColor }} />

                    );
                })}
            </div>

            {/* Only for 1–2 persons, wrap blocks inside .blockWrapper */}
            {(peopleCount === 1 || peopleCount === 2) ? (
                <div className={styles.blockWrapper}>
                    <div className={`${styles.block} ${styles.mainText}`} style={{ backgroundColor: color }}>
                        <p className={styles.sectionTitle}>Information:</p>
                        <div>{renderDraftContent(modul.parent.main_text)}</div>
                    </div>

                    {modul.parent.ziel_gruppe && (
                        <div className={`${styles.block} ${styles.zielGruppe}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Zielgruppe:</div>
                            <div>{renderDraftContent(modul.parent.ziel_gruppe)}</div>

                        </div>
                    )}
                    {modul.parent.mitbringen && (
                        <div className={`${styles.block} ${styles.mitbringen}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Mitbringen:</div>
                            <div>{renderDraftContent(modul.parent.mitbringen)}</div>
                        </div>
                    )}
                    {modul.parent.besonderheit && (
                        <div className={`${styles.block} ${styles.besonderheit}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Besonderheit:</div>
                            <div>{renderDraftContent(modul.parent.besonderheit)}</div>
                        </div>
                    )}
                    {modul.parent.kosten && (
                        <div className={`${styles.block} ${styles.kosten}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Kosten:</div>
                            <div>{renderDraftContent(modul.parent.kosten)}</div>
                        </div>
                    )}
                    {modul.parent.appointments.length > 0 && (
                        <div className={`${styles.block} ${styles.ortZeit}`} style={{ backgroundColor: color }}>
                            <p className={styles.sectionTitle}>Ort & Zeit:</p>

                            <div className={styles.appointmentGrid}>
                                {appointments.slice()
                                    .sort((a, b) => {
                                        const weekdayOrder = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

                                        const getDayIndex = (recurrenceRule) => {
                                            const match = recurrenceRule?.match(/BYDAY=(\w{2})/);
                                            return match ? weekdayOrder.indexOf(match[1]) : -1;
                                        };

                                        const dayA = getDayIndex(a.recurrence_rule);
                                        const dayB = getDayIndex(b.recurrence_rule);

                                        if (dayA !== dayB) return dayA - dayB;

                                        const dateA = a.appointment_date || '';
                                        const dateB = b.appointment_date || '';
                                        if (dateA !== dateB) return dateA.localeCompare(dateB);

                                        return a.start_time.localeCompare(b.start_time);
                                    })
                                    .map((appointment) => {
                                        const days = formatWeekdays(appointment.recurrence_rule);
                                        const time = `${appointment.start_time.slice(0, 5)} – ${appointment.end_time.slice(0, 5)}`;
                                        const location = appointment.location; // from fetched data by ID
                                        const exceptions = appointment.exceptions || [];

                                        return (
                                            <div key={appointment.id} className={styles.appointmentTile}>
                                                <div className={styles.appointmentHeader}>
                                                    <strong>{days}:</strong> {time}
                                                </div>

                                                <div className={styles.locationInfo}>
                                                    <a href={location?.link} target="_blank" rel="noreferrer">
                                                        {location?.name}
                                                    </a>
                                                    {appointment.additional_text && (
                                                        <div className={styles.additionalText}>
                                                            {appointment.additional_text}
                                                        </div>
                                                    )}
                                                </div>

                                                {exceptions.length > 0 && (
                                                    <div className={styles.exceptionsBox}>
                                                        <div className={styles.exceptionsHeader}>
                                                            <strong>⚠️ Ausnahmen:</strong>
                                                            <button
                                                                onClick={() => setShowExceptions(!showExceptions)}
                                                                className={styles.exceptionsToggleButton}
                                                            >
                                                                {showExceptions ? 'Ausblenden' : 'Details anzeigen'}
                                                            </button>
                                                        </div>

                                                        {showExceptions && (
                                                            <ul className={styles.exceptionsList}>
                                                                {exceptions.map((ex) => (
                                                                    <li key={ex.id} className={styles.exceptionItem}>
                                                                        <span className={ex.is_cancelled ? styles.cancelled : styles.modified}>
                                                                            {formatDate(ex.exception_date)} –{" "}
                                                                            {ex.is_cancelled
                                                                                ? "Abgesagt"
                                                                                : `Geändert zu (${formatDate(ex.override_newdate)} um ${ex.override_start.slice(0, 5)}–${ex.override_end.slice(0, 5)})`}
                                                                        </span>
                                                                        {ex.reason && <em>:<br /> {ex.reason}</em>}
                                                                        <hr className={styles.hr} />
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    )}
                    {modul.parent.infos_lehrer && (
                        <div className={`${styles.block} ${styles.infosLehrer}`} style={{ backgroundColor: color }}>
                            <p className={styles.sectionTitle}>Infos Übungsleiter*in:</p>
                            <div>{renderDraftContent(modul.parent.infos_lehrer)}</div>
                        </div>
                    )}
                    {modul.parent.zusatz && (
                        <div className={`${styles.block} ${styles.zusatz}`} style={{ backgroundColor: color }}>
                            <div>{renderDraftContent(modul.parent.zusatz)}</div>
                        </div>
                    )}
                    {modul.parent.abmeldung && (
                        <div className={`${styles.block} ${styles.abmeldung}`} style={{ backgroundColor: color }}>
                            <div>{renderDraftContent(modul.parent.abmeldung)}</div>
                        </div>
                    )}
                </div>
            ) : (
                <>
                    {/* Layout for 0 or 3+ people (default vertical flow) */}
                    {modul.parent.main_text && (
                        <div className={`${styles.block} ${styles.mainText}`} style={{ backgroundColor: color }}>
                            <p className={styles.sectionTitle}>Information:</p>
                            <div>{renderDraftContent(modul.parent.main_text)}</div>
                        </div>
                    )}
                    {modul.parent.ziel_gruppe && (
                        <div className={`${styles.block} ${styles.zielGruppe}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Zielgruppe:</div>
                            <div>{renderDraftContent(modul.parent.ziel_gruppe)}</div>
                        </div>
                    )}
                    {modul.parent.mitbringen && (
                        <div className={`${styles.block} ${styles.mitbringen}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Mitbringen:</div>
                            <div>{renderDraftContent(modul.parent.mitbringen)}</div>
                        </div>
                    )}
                    {modul.parent.besonderheit && (
                        <div className={`${styles.block} ${styles.besonderheit}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Besonderheit:</div>
                            <div>{renderDraftContent(modul.parent.besonderheit)}</div>
                        </div>
                    )}
                    {modul.parent.kosten && (
                        <div className={`${styles.block} ${styles.kosten}`} style={{ backgroundColor: color }}>
                            <div className={styles.sectionTitle}>Kosten:</div>
                            <div>{renderDraftContent(modul.parent.kosten)}</div>
                        </div>
                    )}
                    {modul.parent.appointments.length > 0 && (
                        <div className={`${styles.block} ${styles.ortZeit}`} style={{ backgroundColor: color }}>
                            <p className={styles.sectionTitle}>Ort & Zeit:</p>

                            <div className={styles.appointmentGrid}>
                                {appointments.map((appointment) => {
                                    const days = formatWeekdays(appointment.recurrence_rule);
                                    const time = `${appointment.start_time.slice(0, 5)} – ${appointment.end_time.slice(0, 5)}`;
                                    const location = appointment.location; // from fetched data by ID
                                    const exceptions = appointment.exceptions || [];

                                    return (
                                        <div key={appointment.id} className={styles.appointmentTile}>
                                            <div className={styles.appointmentHeader}>
                                                <strong>{days}:</strong> {time}
                                            </div>

                                            <div className={styles.locationInfo}>
                                                <a href={location?.link} target="_blank" rel="noreferrer">
                                                    {location?.name}
                                                </a>
                                            </div>

                                            {exceptions.length > 0 && (
                                                <div className={styles.exceptionsBox}>
                                                    <div className={styles.exceptionsHeader}>
                                                        <strong>⚠️ Ausnahmen:</strong>
                                                        <button
                                                            onClick={() => setShowExceptions(!showExceptions)}
                                                            className={styles.exceptionsToggleButton}
                                                        >
                                                            {showExceptions ? 'Ausblenden' : 'Details anzeigen'}
                                                        </button>
                                                    </div>

                                                    {showExceptions && (
                                                        <ul className={styles.exceptionsList}>
                                                            {exceptions.map((ex) => (
                                                                <li key={ex.id} className={styles.exceptionItem}>
                                                                    <span className={ex.is_cancelled ? styles.cancelled : styles.modified}>
                                                                        {formatDate(ex.exception_date)} –{" "}
                                                                        {ex.is_cancelled
                                                                            ? "Abgesagt"
                                                                            : `Geändert (${formatDate(ex.override_newdate)} um ${ex.override_start.slice(0, 5)}–${ex.override_end.slice(0, 5)})`}
                                                                    </span>
                                                                    {ex.reason && <em>: {ex.reason}</em>}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {modul.parent.infos_lehrer && (
                        <div className={`${styles.block} ${styles.infosLehrer}`} style={{ backgroundColor: color }}>
                            <p className={styles.sectionTitle}>Infos Übungsleiter*in:</p>
                            <div>{renderDraftContent(modul.parent.infos_lehrer)}</div>
                        </div>
                    )}
                    {modul.parent.zusatz && (
                        <div className={`${styles.block} ${styles.zusatz}`} style={{ backgroundColor: color }}>
                            <div>{renderDraftContent(modul.parent.zusatz)}</div>
                        </div>
                    )}
                    {modul.parent.abmeldung && (
                        <div className={`${styles.block} ${styles.abmeldung}`} style={{ backgroundColor: color }}>
                            <div>{renderDraftContent(modul.parent.abmeldung)}</div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default SportModul;